import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AppSettingService } from '../app.service';
import { UserInfoService } from '../user/user-info.service';

@Injectable({
	providedIn: 'root'
})
export class InstitutionAPIService {
	constructor(
		private userInfo: UserInfoService,
		private http: HttpClient
	) { }

	private url = AppSettingService.appConfig.JourneyAPIUrl + "Institution";

	getInstitution(institutionCode: string): Observable<any> {
		institutionCode = (institutionCode ?? "").trim();
		if (institutionCode === '') {
			throw 'please provide institution';
		}
		return this.http.get<any>(
			this.url + "/" + encodeURIComponent(institutionCode),
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	search(type: "SCHOOL" | "NCES" | "IPEDS", kw: string, limit: number, offset: number): Observable<any> {
		return this.http.get<any>(
			this.url + "/Search/" + type + "?keyword=" + encodeURIComponent(kw) + "&limit=" + limit.toString() + "&offset=" + offset.toString(),
		);
	};

	subscribe(institutionCode: string): Observable<any> {
		institutionCode = (institutionCode??"").trim();
		if (institutionCode === '') {
			throw 'please provide institution';
		}
		return this.http.post<any>(
			this.url + "/" + institutionCode + "/Subscribe",
			null,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	unsubscribe(subscribeId: string): Observable<any> {
		subscribeId = (subscribeId??"").trim();
		if (subscribeId === '') {
			throw 'please provide subscribe Id';
		}
		return this.http.get<any>(
			this.url + "/Unsubscribe/" + subscribeId,
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}

	getSubscription(institutionCode: string): Observable<any> {
		institutionCode = (institutionCode??"").trim();
		if (institutionCode === '') {
			throw 'please provide institution';
		}
		return this.http.get<any>(
			this.url + "/" + institutionCode + "/Subscription",
			{
				withCredentials: true,
				headers: { 'Authorization': this.userInfo.authHeader(false) }
			}
		);
	}
}


@Injectable({
	providedIn: 'root'
})
export class InstitutionWelcomeService {
	get welcomeTourStatus(): boolean {
		return sessionStorage.getItem('institutionWelcome') === "false" ? false : true;
	}
	set welcomeTourStatus(v: boolean) {
		if (v == null) {
			sessionStorage.removeItem("institutionWelcome");
		}
		else {
			sessionStorage.setItem('institutionWelcome', v.toString());
		}
	}

	constructor(
		private route: ActivatedRoute
	) {
		// default to false if Unsubscribe is provided in the url
		if (this.route.snapshot.queryParams['UnsubscribeMetricReport']) {
			this.welcomeTourStatus = false;
		}
	}
}
